import React from 'react';
import {
  CommonOnError, CommonScrollIntoView, CommonRequired
} from 'types/props';
import ValidationElement, {
  ValidationElementProps,
} from 'components/Form/ValidationElement/ValidationElement';
import classnames from 'classnames';
import { BranchCollectionModel } from 'forms/shared/types';
import BranchCollection from 'components/Form/BranchCollection';
import { CourtMartialChargeItemModel } from 'forms/sections/military/disciplinary/types';
import { i18n } from 'config/locales';
import CourtMartialChargeCollectionItem from './CourtMartialChargeCollectionItem';

interface Props extends ValidationElementProps, BranchCollectionModel<CourtMartialChargeItemModel> {
  attribute?: string;
  className?: string;
  formType?: string;
  onError?: CommonOnError;
  onUpdate: (values: BranchCollectionModel<CourtMartialChargeItemModel>) => void;
  required?: CommonRequired;
  scrollIntoView?: CommonScrollIntoView;
}

export default class CourtMartialChargeCollection extends ValidationElement<Props> {
  updateBranch = (values: BranchCollectionModel<CourtMartialChargeItemModel>) => {
    this.props.onUpdate({
      ...values,
    });
  };

  render() {
    return (
      <div className={classnames('court-martial-charge-list', this.props.className)}>
        {/* PVQ: What were your charges under the Uniform Code of [...] */}
        {/* PVQ: Do you have another charge for this offense to report? */}
        <BranchCollection
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...this.props}
          appendLabel={i18n.t('military.pvq.disciplinary.para.courtmartialchargeanother')}
          appendSize="h4"
          hideInitialBranchQuestionAssumeYes
          label={i18n.t('military.pvq.disciplinary.para.courtmartialchargeinfo')}
          labelSize="h4"
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          onError={this.props.onError}
          onUpdate={this.updateBranch}
          scrollIntoView={this.props.scrollIntoView}
        >
          <CourtMartialChargeCollectionItem
            attribute={this.props.attribute}
            bind
            formType={this.props.formType}
            name="Item"
            required={this.props.required}
          />
        </BranchCollection>
      </div>
    );
  }
}
